<template>
  <v-app-bar elevation=1 class="header" floating >
    <div class="h-100 d-flex flex-row justify-center align-center" @click="goTo('/')">
      <img :src="require('@/assets/images/Logo.png')" class="mx-3 pointer h-100">
      <v-chip size="small" color="pink" variant="tonal" style="position: absolute; left: 150px;">
        Beta 0.2.1
      </v-chip>
    </div>

    <template v-if="!isCompact">
      <v-tabs v-model="tab" color="primary" class="w-100" hide-slider>
        <v-spacer/>
        <template v-for="item of navItems.default">
          <v-tab :value="item.href" @click="goTo(item.goTo)">
            <div class="d-flex flex-column align-center py-2">
              <img v-if="item.img" height="21" :src="item.img" />
              <v-icon color="primary" class="mr-1" v-else size=32>{{ item.icon }}</v-icon>
              <span :class="'text-subtitle-2 ' + ($router.currentRoute.value.path == item.goTo ? 'text-primary' : 'text-white')">{{ item.title }}</span>
            </div>
          </v-tab>
        </template>

        <v-spacer/>

        <template v-if="userStore && userStore.isLoggedIn && userStore.profile && userStore.profile.role && userStore.profile.role == 'admin'" v-for="item of navItems.admin">
          <v-tab :value="item.href" @click="goTo(item.goTo)">
            <div class="d-flex flex-column align-center py-2">
              <img v-if="item.img" height="21" :src="item.img" />
              <v-icon color="primary" class="mr-1" v-else size=32>{{ item.icon }}</v-icon>
              <span :class="'text-subtitle-2 ' + ($router.currentRoute.value.path == item.goTo ? 'text-primary' : 'text-white')">{{ item.title }}</span>
            </div>
          </v-tab>
        </template>

        <v-tab @click.prevent.stop="openLogin" v-if="!userStore.isLoggedIn">
          <div class="d-flex flex-row align-center py-2">
            <v-icon color="primary" class="mr-1" size=18>mdi-lock</v-icon>
            <span class="'text-subtitle-2 text-white">Se connecter</span>
          </div>
        </v-tab>
        <v-tab v-else-if="userStore.profile && userStore.profile.username">
          <div class="d-flex flex-column align-center py-2">
            <v-icon color="primary" class="mr-1" size=32>mdi-account</v-icon>
            <span class="text-subtitle-2 text-primary">{{ userStore.profile.username }}</span>
          </div>
          <v-menu offset-y activator="parent">
            <v-list>
              <v-list-item @click.prevent.stop="goTo('/parameters')">
                <v-list-item-title class="font-weight-100 d-flex align-center gap-3 text-white">
                  Mon profil
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click.prevent.stop="logout">
                <v-list-item-title class="font-weight-100 d-flex align-center gap-3 text-error">
                  Se déconnecter
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-tab>
      </v-tabs>
    </template>

    <template v-else>
      <v-spacer />
      <v-btn color=primary>
        <v-icon size=xx-large>mdi-menu</v-icon>
        <v-menu activator=parent>
          <v-list min-width=80vw>
            <template v-for="item of navItems.default">
              <v-list-item @click="goTo(item.goTo)">
                <v-list-item-title class="font-weight-100 d-flex align-center gap-3">
                  <img v-if="item.img" height=28 width=28 cover :src="item.img" />
                  <v-icon color="primary" class="ma-1" v-else size=large>{{ item.icon }}</v-icon>
                  {{ item.title }}
                </v-list-item-title>
              </v-list-item>
            </template>
            <template v-if="userStore && userStore.isLoggedIn && userStore.profile && userStore.profile.role && userStore.profile.role == 'admin'" v-for="item of navItems.admin">
              <v-list-item @click="goTo(item.goTo)">
                <v-list-item-title class="font-weight-100 d-flex align-center gap-3">
                  <img v-if="item.img" height=28 width=28 cover :src="item.img" />
                  <v-icon color="primary" class="ma-1" v-else size=large>{{ item.icon }}</v-icon>
                  {{ item.title }}
                </v-list-item-title>
              </v-list-item>
            </template>

            <v-divider color="primary" class="border-opacity-100"></v-divider>

            <v-list-item @click.prevent.stop="openLogin" v-if="!userStore.isLoggedIn">
              <v-list-item-title class="font-weight-100 d-flex align-center gap-3">
                <v-icon color="primary" class="mr-1" size=18>mdi-lock</v-icon>
                Se connecter
              </v-list-item-title>
            </v-list-item>
            <template v-else-if="userStore.profile && userStore.profile.username">
              <v-list-item @click.prevent.stop="goTo('/parameters')" v-if="userStore.profile.role && userStore.profile.role == 'admin'">
                <v-list-item-title class="font-weight-100 d-flex align-center gap-3 text-primary">
                  <v-icon>mdi-account</v-icon>
                  {{ userStore.profile.username }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click.prevent.stop="logout">
                <v-list-item-title class="font-weight-100 d-flex align-center gap-3 text-error">
                  Se déconnecter
                </v-list-item-title>
              </v-list-item>
            </template>

          </v-list>
        </v-menu>
      </v-btn>
    </template>

  </v-app-bar>
</template>

<script>
import { useUserStore } from '@/store/user.js'

import navItems from '@/config/navItems.js'

export default {
  props : ['themes', 'theme', 'isLoggedIn', 'settings'],
  data() {
    return {
      userStore: useUserStore(),
      tab: null,
      navItems,
    }
  },
  methods: {
    openLogin() {
      this.$emit('openLogin')
    },
    logout() {
      this.$emit('logout')
    },
    goTo(pageName) {
      this.$router.push(pageName).then(() => {
        setTimeout(() => {
          scrollTo()
        }, 200)
      })
    }
  },
  computed: {
    isCompact() {
      return this.$vuetify.display.smAndDown
    },
  }
}
</script>